import { useQuery } from "@tanstack/react-query";
import { getAuditLog, getAuditMeta } from "./audit";
import { auditQueryKeys } from "./query-keys";

export function useGetAuditLog(filters) {
  return useQuery({
    queryKey: auditQueryKeys.list(filters),
    queryFn: () => getAuditLog(filters),
    placeholderData: (previous) => previous,
  });
}

export function useGetAuditMeta() {
  return useQuery({
    queryKey: auditQueryKeys.meta(),
    queryFn: getAuditMeta,
    staleTime: 60_000,
  });
}
